import { render, staticRenderFns } from "./CountryCode.vue?vue&type=template&id=020e5d38&scoped=true&"
import script from "./CountryCode.vue?vue&type=script&lang=ts&"
export * from "./CountryCode.vue?vue&type=script&lang=ts&"
import style0 from "./CountryCode.vue?vue&type=style&index=0&id=020e5d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e5d38",
  null
  
)

export default component.exports